export default __webpack_public_path__ + "static/media/pictogramBeaconInsights64.78313696.svg";